var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dialogue", {
        attrs: {
          title: "Add Box",
          paragraph: _vm.box_dialogue_text,
          button_names: ["Yes", "No"],
          show: _vm.box_dialogue
        },
        on: { dialogue: _vm.addBox, cancel: _vm.cancelBox }
      }),
      _vm._v(" "),
      _c("checkitem", {
        attrs: { show: _vm.checkOpen, isIn: _vm.checkIsIn, itemId: _vm.itemId },
        on: { cancel: _vm.closeCheck, dialogue: _vm.checkItem }
      }),
      _vm._v(" "),
      _c("layout-1", {
        key: _vm.updateKey,
        staticStyle: { width: "100%", height: "calc(100vh)" },
        attrs: {
          table_name: "Inventory",
          filter_options: _vm.filters,
          id: _vm.pageid,
          searchbar: true,
          navbar: true,
          nav_items: ["Inventory List", "Edit Inventory List", "Scan Item"],
          nav_item_perms: ["88", "88", "89"],
          button_perm: "88",
          button_name: "Select",
          term: _vm.term,
          reroute: "/0322",
          select_reroute: true,
          usePages: true
        },
        on: { check: _vm.check }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83cb713c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83cb713c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Inventory.vue
// module id = 572
// module chunks = 0